import styled from 'styled-components'

export const Container = styled.div`
display: flex;
margin: 0 0 1rem 0;
align-items: center;

span{
font-size: .875rem;
cursor: pointer;
}

svg,span{
    margin-right:.25rem;
}

svg{
    color: var(--Azul);
}

span:hover{
    text-decoration: underline;
}

span:last-child{
    font-weight: bold;
}
`
